import React, { useState, useCallback, useContext } from "react";
import { Card, Autocomplete, Stack, Tag, Text } from "@shopify/polaris";
import {useTranslation} from "react-i18next";

export default function FormTags(props) {
  const { t } = useTranslation();
  const { tag_joins_attributes, all_tags } = props.location;
  
  // Add defensive check for all_tags
  if (!all_tags || !Array.isArray(all_tags)) {
    return (
      <Card title={t("settings.tags.title")} sectioned>
      </Card>
    );
  }
  
  const allTagOptions = all_tags.map((entry) => {
    return {
      title: entry.group,
      options: entry.tags.map((tag) => {
        return {
          value: tag.title,
          label: tag.title,
        };
      }),
    };
  });

  const [tagFieldInput, setTagFieldInput] = useState("");
  const [tagOptions, setTagOptions] = useState(allTagOptions);

  // Filter autocomplete options
  const updateTagFieldInput = useCallback(
    (value) => {
      setTagFieldInput(value);
      if (value === "") {
        setTagOptions(allTagOptions);
        return;
      }
      const filterRegex = new RegExp(value, "i");
      const resultOptions = [];
      allTagOptions.forEach((opt) => {
        const lol = opt.options.filter((option) =>
          option.label.match(filterRegex)
        );
        resultOptions.push({
          title: opt.title,
          options: lol,
        });
      });

      setTagOptions(resultOptions);
    },
    [all_tags]
  );

  // Selecting tags

  // Flat list of tags
  const allTags = all_tags.map((group) => group.tags).flat();

  // Get existing tags from tag_ids of tag_joins_attributes
  const existingTags = allTags.filter((tag) => {
    return tag_joins_attributes.map((tj) => tj.tag_id).includes(tag.id);
  });

  const [selectedTags, setSelectedTags] = useState(
    existingTags.map((tag) => tag.title)
  );

  function removeTag(tagTitle) {
    let newTags = [...selectedTags].filter((tag) => tag !== tagTitle);
    updateSelectedTags(newTags);
  }

  function updateSelectedTags(selectedTags) {
    setSelectedTags(selectedTags);
    let newTagOptions = [];
    // Build tag_joins_attributes from selected tags
    const newTagJoinAttributes = selectedTags.map((tagTitle) => {
      const tag = allTags.find((tag) => tag.title == tagTitle);

      if (tag) {
        const existingTagJoin = tag_joins_attributes.find(
          (tagJoin) => tagJoin.tag_id == tag.id
        );
        if (existingTagJoin) {
          return {
            id: existingTagJoin.id,
            location_id: props.location.id,
            tag_id: tag.id,
          };
        } else {
          // Doesnt have existing tag join, create a join
          return {
            location_id: props.location.id,
            tag_id: tag.id,
          };
        }
      } else {
        // Completely new tag
        // Add to tagTitle to options
        newTagOptions.push(tagTitle);
        return {
          location_id: props.location.id,
          tag_attributes: {
            shop_id: props.location.shop_id,
            title: tagTitle,
          },
        };
      }
    });

    const tagJoinsToRemove = tag_joins_attributes.map((tagJoin) => {
      const tag = allTags.find((tag) => tag.id == tagJoin.tag_id);
      if (!tag) {
        return;
      }

      const tagIsSelected = selectedTags.includes(tag.title);
      const tagJoinExists = tagJoin.id !== undefined;

      if (!tagIsSelected && tagJoinExists) {
        let newTagJoin = tagJoin;
        newTagJoin._destroy = true;
        return newTagJoin;
      }
    });

    // Join these arrays and get rid of undefined from when we return nothing from map
    const newTagJoinsAttributes = newTagJoinAttributes
      .concat(tagJoinsToRemove)
      .filter((attribute) => attribute !== undefined);

    // Set new location

    // Havent got round to it because its complicated but add newTagOptions to newLocation.all_tags
    // So that when we create a new tag it shows up in the list
    // console.log("new tag options", newTagOptions);
    props.setLocation((oldLocation) => {
      return { ...oldLocation, tag_joins_attributes: newTagJoinsAttributes };
    });
  }

  const autoCompleteTextField = (
    <Autocomplete.TextField
      label={t("settings.tags.title")}
      labelHidden
      onChange={updateTagFieldInput}
      value={tagFieldInput}
      placeholder="Wifi, Shoe Fitting, Tropical Fish"
      autoComplete="off"
      // prefix={<Icon source={SearchMinor} color="base" />}
    />
  );

  let extraOptions = [];
  if (
    tagFieldInput &&
    !allTags.map((tag) => tag.title).includes(tagFieldInput)
  ) {
    extraOptions = [
      {
        options: [
          {
            label: (
              <Text variant="bodyMd" as="span">
                <b>{t("common.add")}</b> {tagFieldInput}
              </Text>
            ),
            value: tagFieldInput,
          },
        ],
      },
    ];
  }

  return (
    <Card title={t("settings.tags.title")} sectioned>
      <Autocomplete
        textField={autoCompleteTextField}
        selected={selectedTags}
        options={extraOptions.concat(tagOptions)}
        onSelect={(newTags) => {
          updateTagFieldInput("");
          updateSelectedTags(newTags);
        }}
        allowMultiple
        preferredPosition="below"
      />
      <div style={{ marginTop: "0.8rem" }}>
        <Stack spacing="tight" wrap={true}>
          {selectedTags.map((tag) => {
            return (
              <Tag key={tag} onRemove={() => removeTag(tag)}>
                {tag}
              </Tag>
            );
          })}
        </Stack>
        {/* {props.location.tag_joins_attributes.map((attr) => {
          return <p>{JSON.stringify(attr)}</p>;
        })} */}
      </div>
    </Card>
  );
}
